// Agent Tools Constants

export const API_URL = process.env.REACT_APP_BACKEND_URL;

export const HTTP_METHODS = ['GET', 'POST', 'PUT', 'DELETE', 'PATCH', 'HEAD', 'OPTIONS'];

export const AUTH_TYPES = [
  { value: 'none', label: 'Sin Autenticación' },
  { value: 'bearer_token', label: 'Bearer Token' },
  { value: 'api_key_header', label: 'API Key (Header)' },
  { value: 'api_key_query', label: 'API Key (Query)' },
  { value: 'basic_auth', label: 'Basic Auth' },
  { value: 'custom_header', label: 'Header Personalizado' }
];

export const CONTENT_TYPES = [
  { value: 'application/json', label: 'JSON' },
  { value: 'application/x-www-form-urlencoded', label: 'Form URL Encoded' },
  { value: 'multipart/form-data', label: 'Form Data' },
  { value: 'text/plain', label: 'Text' },
  { value: 'application/xml', label: 'XML' }
];

export const CATEGORIES = [
  { code: 'messaging', name: 'Mensajería' },
  { code: 'crm', name: 'CRM' },
  { code: 'external_api', name: 'API Externa' },
  { code: 'internal_api', name: 'API Interna' },
  { code: 'notification', name: 'Notificaciones' },
  { code: 'email', name: 'Email' },
  { code: 'sms', name: 'SMS' },
  { code: 'webhook', name: 'Webhook' },
  { code: 'ai', name: 'IA/ML' },
  { code: 'other', name: 'Otro' }
];

export const DEFAULT_FORM_DATA = {
  name: '',
  description: '',
  category: 'external_api',
  method: 'GET',
  base_url: '',
  endpoint: '',
  headers: [],
  content_type: 'application/json',
  query_params: [],
  body_type: 'json',
  body_json: {},
  body_form: [],
  body_raw: '',
  auth: {
    type: 'none',
    bearer_token: '',
    api_key_name: 'X-API-Key',
    api_key_value: '',
    basic_username: '',
    basic_password: '',
    custom_header_name: '',
    custom_header_value: ''
  },
  timeout_seconds: 30,
  retry_count: 0,
  follow_redirects: true,
  verify_ssl: true,
  expected_status_codes: [200, 201, 204],
  response_type: 'json',
  response_mappings: [],
  input_variables: [],
  output_variables: [],
  test_payload: {},
  status: 'active',
  tags: []
};
